<div class="appContentsContainer">
  <form
    [formGroup]="concessionaire"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm wrapHalfRows"
  >
    <div class="collapseButtonContainer">
      <button
        type="button"
        *ngIf="!sectionHidden.datos"
        class="submitSearchButton"
        (click)="sectionHidden.datos = !sectionHidden.datos"
      >
        <em class="fas fa-angle-up"></em>
      </button>
      <button
        type="button"
        *ngIf="sectionHidden.datos"
        class="submitSearchButton"
        (click)="sectionHidden.datos = !sectionHidden.datos"
      >
        <em class="fas fa-angle-down"></em>
      </button>
      <div class="pageTitle collapsibleTitle">
        <div class="title halfTitle" *ngIf="operation === 'creacion'">
          {{ "concessionaire.titleCreate" | translate }}
        </div>
        <div class="title halfTitle" *ngIf="operation === 'edicion'">
          {{ "concessionaire.titleEdit" | translate }}
        </div>
      </div>
    </div>

    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coId" for="coId">Identificador</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coId"
              [readonly]="operation === 'edicion'"
              maxlength="8"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coNombre" for="coNombre">Nombre</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coNombre"
              maxlength="64"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coDireccionEnvio" for="coDireccionEnvio"
                >Dirección</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coDireccionEnvio"
              maxlength="64"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />

            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coLocalidadEnvio" for="coLocalidadEnvio"
                >Población</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coLocalidadEnvio"
              maxlength="32"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />

            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coProvinciaEnvio" for="coProvinciaEnvio"
                >Provincia</label
              >
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coProvinciaEnvio"
              maxlength="32"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />

            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coZipEnvio" for="coZipEnvio">CP/Zip</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coZipEnvio"
              maxlength="16"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />

            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coPaisEnvio" for="coPaisEnvio">País</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coPaisEnvio"
              maxlength="32"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />

            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div
        class="row compressedRow"
        style="
          min-height: 40px !important;
          height: 40px !important;
          max-height: 40px !important;
        "
      >
        <div
          class="itemContainer col"
          style="
            min-height: 40px !important;
            height: 40px !important;
            max-height: 40px !important;
          "
        >
          <div
            class="seachLabel inputLabelContainer"
            style="
              min-height: 40px !important;
              height: 40px !important;
              max-height: 40px !important;
            "
          >
            <div
              class="inputLabel"
              style="
                min-height: 40px !important;
                height: 40px !important;
                max-height: 40px !important;
              "
            >
              <label
                >¿Utilizará la misma dirección para el envio y para la
                facturación de los certificados?</label
              >
            </div>
          </div>
          <div
            class="inputContainer"
            style="
              min-height: 40px !important;
              height: 40px !important;
              max-height: 40px !important;
            "
          >
            <div class="datosEspecificosRadioGroup">
              <div class="radioText">Sí</div>
              <input
                class="datosEspecificosRadio"
                id="sameAddress"
                type="radio"
                value="yes"
                name="sameAddress"
                style="cursor: pointer !important"
                (change)="changeAddress($event)"
                [disabled]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
              <div class="radioText">No</div>
              <input
                class="datosEspecificosRadio"
                id="sameAddress"
                type="radio"
                value="no"
                name="sameAddress"
                style="cursor: pointer !important"
                (change)="changeAddress($event)"
                [disabled]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coDireccionFacturacion" for="coDireccionFacturacion"
                >Direccion facturación
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coDireccionFacturacion"
              maxlength="64"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coLocalidadFacturacion" for="coLocalidadFacturacion"
                >Poblacion de facturación
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coLocalidadFacturacion"
              maxlength="32"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coProvinciaFacturacion" for="coProvinciaFacturacion"
                >Provincia de facturacion
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coProvinciaFacturacion"
              maxlength="32"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coZipFacturacion" for="coZipFacturacion"
                >CP/Zip facturación
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coZipFacturacion"
              maxlength="16"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coPaisFacturacion" for="coPaisFacturacion"
                >País de facturación
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="coPaisFacturacion"
              maxlength="32"
              [readonly]="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                hasRole()
              "
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="coRegion" for="coRegion">Región </label>
            </div>
          </div>
          <div class="inputContainer">
            <select
              formControlName="coRegion"
              *ngIf="
                (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole();
                else regionElse
              "
              disabled
            >
              <option *ngFor="let region of regionsList" value="{{ region }}">
                {{ region }}
              </option>
            </select>
            <ng-template #regionElse>
              <select formControlName="coRegion">
                <option *ngFor="let region of regionsList" value="{{ region }}">
                  {{ region }}
                </option>
              </select>
            </ng-template>

            <div class="supIndex">*</div>
          </div>
        </div>
      </div>
      <ng-container *appPermsRoles="[roles.REVISOR, roles.ADMIN]">
        <div class="row compressedRow" *ngIf="operation !== 'mod-datos-pers'">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="coActivo">Activo</label>
              </div>
            </div>

            <div class="inputContainer selectorSearchinput">
              <input
                class="inputSearch"
                type="checkbox"
                formControlName="coActivo"
              />
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="collapseButtonContainer">
      <button
        type="button"
        *ngIf="!sectionHidden.responsableGroup"
        class="submitSearchButton"
        (click)="
          sectionHidden.responsableGroup = !sectionHidden.responsableGroup
        "
      >
        <em class="fas fa-angle-up"></em>
      </button>
      <button
        type="button"
        *ngIf="sectionHidden.responsableGroup"
        class="submitSearchButton"
        (click)="
          sectionHidden.responsableGroup = !sectionHidden.responsableGroup
        "
      >
        <em class="fas fa-angle-down"></em>
      </button>
      <div class="pageTitle collapsibleTitle">
        <div class="title halfTitle">Datos de responsables</div>
      </div>
    </div>

    <div
      class="halfGroupVersions responsables"
      *ngIf="!sectionHidden.responsableGroup"
    >
      <div class="halfGroup">
        <div class="subSectionTitle">Responsable 1 (opcional)</div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coNombre1">Nombre</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coNombre1"
                type="text"
                formControlName="coNombre1"
                maxlength="64"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coApellidos1">Apellidos</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coApellidos1"
                type="text"
                formControlName="coApellidos1"
                maxlength="32"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coTelefono1">Teléfono</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coTelefono1"
                type="number"
                formControlName="coTelefono1"
                maxlength="16"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel"><label for="coEmail1">E-mail</label></div>
            </div>
            <div class="inputContainer">
              <input
                id="coEmail1"
                type="text"
                formControlName="coEmail1"
                maxlength="128"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>
      </div>

      <div class="halfGroup">
        <div class="subSectionTitle">Responsable 2 (opcional)</div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coNombre2">Nombre</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coNombre2"
                type="text"
                formControlName="coNombre2"
                maxlength="64"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coApellidos2">Apellidos</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coApellidos2"
                type="text"
                formControlName="coApellidos2"
                maxlength="32"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coTelefono2">Teléfono</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coTelefono2"
                type="number"
                formControlName="coTelefono2"
                maxlength="16"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel"><label for="coEmail2">E-mail</label></div>
            </div>
            <div class="inputContainer">
              <input
                id="coEmail2"
                type="text"
                formControlName="coEmail2"
                maxlength="128"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>
      </div>

      <div class="halfGroup">
        <div class="subSectionTitle">Responsable 3 (opcional)</div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coNombre3">Nombre</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coNombre3"
                type="text"
                formControlName="coNombre3"
                maxlength="64"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coApellidos3">Apellidos</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coApellidos3"
                type="text"
                formControlName="coApellidos3"
                maxlength="32"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coTelefono3">Teléfono</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coTelefono3"
                type="number"
                formControlName="coTelefono3"
                maxlength="16"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel"><label for="coEmail3">E-mail</label></div>
            </div>
            <div class="inputContainer">
              <input
                id="coEmail3"
                type="text"
                formControlName="coEmail3"
                maxlength="128"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>
      </div>

      <div class="halfGroup">
        <div class="subSectionTitle">Responsable 4 (opcional)</div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coNombre4">Nombre</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coNombre4"
                type="text"
                formControlName="coNombre4"
                maxlength="64"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coApellidos4">Apellidos</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coApellidos4"
                type="text"
                formControlName="coApellidos4"
                maxlength="32"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label for="coTelefono4">Teléfono</label>
              </div>
            </div>
            <div class="inputContainer">
              <input
                id="coTelefono4"
                type="number"
                formControlName="coTelefono4"
                maxlength="16"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>

        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel"><label for="coEmail4">E-mail</label></div>
            </div>
            <div class="inputContainer">
              <input
                id="coEmail4"
                type="text"
                formControlName="coEmail4"
                maxlength="128"
                [readonly]="
                  (!concessionaire.value.coActivo && operation === 'edicion') ||
                  hasRole()
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fullGroup">
      <div class="formGroupButtons detalleFormGroupButtonsFooter">
        <div class="formButton" *ngIf="routingRoot == ''">
          <button
            class="submitButton"
            type="button"
            *ngIf="concessionaire.pristine"
            (click)="goList()"
          >
            <em class="fas fa-caret-square-left"></em>
          </button>
          <button
            type="button"
            class="submitButton"
            *ngIf="!concessionaire.pristine"
            [swal]="confirmSwal"
          >
            <em class="fas fa-caret-square-left"></em>
          </button>
        </div>
        <div class="formButton" *ngIf="routingRoot != ''">
          <button
            class="submitButton"
            type="button"
            *ngIf="concessionaire.pristine"
            (click)="goList()"
          >
            <em class="fas fa-times fa-2x backButtonAlign"></em>
          </button>
          <button
            type="button"
            class="submitButton"
            *ngIf="!concessionaire.pristine"
            [swal]="confirmSwal"
          >
            <em class="fas fa-times fa-2x backButtonAlign"></em>
          </button>
        </div>

        <div class="middleButtonAceptarContainer notFullWidth">
          <div class="middleButtonAceptar formButton">
            <button
              class="submitButton"
              type="submit"
              *appPermsRoles="[
                roles.ADMIN,
                roles.RHOMOLOG,
                roles.IMPORT,
                roles.REVISOR,
                roles.AAVANZA,
                roles.TECNICO,
                roles.RREGION
              ]"
            >
              {{ "commons.ok" | translate }}
            </button>
          </div>
        </div>
      </div>

      <swal
        #confirmSwal
        html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
        icon="warning"
        [showCancelButton]="true"
        [swalOptions]="{
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          allowEscapeKey: false,
          allowOutsideClick: false
        }"
        [focusCancel]="true"
        (confirm)="goList()"
      >
      </swal>
    </div>
  </form>
</div>
